import { useCallback, useEffect, useState } from "react";
import api from "../../../../utils/axiosInstance";
import { toast } from "../../../../components/Toast/toast";
import RemindersView from "./RemindersView";
import RemindersForm from "./RemindersForm";

const RemindersPage = () => {
  const [reminders, setReminders] = useState([]);
  const [freelance, setFreelance] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [editing, setEditing] = useState(false);

  const load = useCallback(async () => {
    try {
      const res = await api.get("/reminders");
      setReminders(res.data.data.reminders);
      setFreelance(Boolean(res.data.data.freelance));
    } catch (err) {
      console.error("Failed to load reminders", err);
      setError(err.response?.data?.message || "Failed to load reminders.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const handleSave = async (payload) => {
    try {
      const res = await api.put("/reminders", payload);
      setReminders(res.data.data.reminders);
      toast.success(res.data.message || "Reminders updated.");
      return true;
    } catch (err) {
      toast.error(
        err.response?.data?.error ||
          err.response?.data?.message ||
          "Could not save the reminders."
      );
      return false;
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center py-10">
        <div className="h-8 w-8 animate-spin rounded-full border border-gray-300 border-t-brand-600" />
      </div>
    );
  }

  if (error) return <p className="text-sm text-danger-600">{error}</p>;

  if (editing) {
    return (
      <RemindersForm
        reminders={reminders}
        onSave={handleSave}
        onCancel={() => setEditing(false)}
      />
    );
  }

  return (
    <RemindersView
      reminders={reminders}
      freelance={freelance}
      onEdit={() => setEditing(true)}
    />
  );
};

export default RemindersPage;